import { DateTimePicker as ShellDateTimePicker, DateTimePickerProps } from '@e3dc-react/shell/Elements/InputFields/picker/DateTimePicker'
import React, { FC, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import { useTheme } from '@mui/material'
import moment from '@e3dc-react/shell/Libs/moment'

interface LocalProps extends DateTimePickerProps {
  name: string
  format?: string
}

/**
 * Date time picker component for formik
 * Changes the formik field value based on passed name from props
 */
const DateTimePicker: FC<LocalProps> = props => {
  const theme = useTheme()
  const { handleChange: handleFieldChange } = useFormikContext()
  const [, field] = useField(props.name)

  const hasError = useMemo<boolean>(() => {
    return Boolean(field.error && field.touched)
  }, [field])

  const helperText = useMemo<string | undefined>(() => {
    return field.error
  }, [field.error])

  return (
    <ShellDateTimePicker
      {...props}
      onChange={value => handleFieldChange(props.name)(`${value?.format()}`)}
      value={moment(field.value)}
      inputFormat={props.format}
      iconPaddingRight={theme.spacing(2)}
      label={props.label}
      error={hasError}
      helperText={hasError ? helperText : undefined}
    />
  )
}

DateTimePicker.displayName = 'DateTimePicker'

export default DateTimePicker
